initialCost